import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class BenefitInquiryType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._claims_ids = init.claim_ids
    this._config_change_required = init.config_change_required
    this._created_at = init.created_at
    this._employee_id = init.employee_id
    this._form_attachment = init.form_attachment
    this._id = init.id
    this._question = init.question
    this._topic_area = init.topic_area
    this._updated_at = init.updated_at
  }

  static shape = {
    claim_ids: PropTypes.array,
    config_change_required: PropTypes.bool,
    created_at: PropTypes.number,
    employee_id: PropTypes.number,
    form_attachment: PropTypes.string,
    id: PropTypes.number,
    question: PropTypes.string,
    topic_area: PropTypes.string,
    updated_at: PropTypes.number
  }

  get claim_ids() {
    return this._claims_ids
  }

  get config_change_required() {
    return this._config_change_required
  }

  get created_at() {
    return this._created_at
  }

  get employee_id() {
    return this._employee_id
  }

  get form_attachment() {
    return this._form_attachment
  }

  get id() {
    return this._id
  }

  get question() {
    return this._question
  }

  get topic_area() {
    return this._topic_area
  }

  get updated_at() {
    return this._updated_at
  }
}

export default BenefitInquiryType
